import { BehaviourType } from "entities/App/model/types";
import { SeaReferenceTypesDTO } from "entities/shared/seaCard.types";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { QueryParamsManager } from "shared/lib/queryParams.lib";
import { store } from "shared/lib/redux";
import { ValueOf } from "shared/lib/typeCheck.lib";

export type PossibleUrlQueryParams = {
  number: string;
  reference_number: string;
  airline: string;
  awb_number: string;
  container: string;
  type: ValueOf<typeof SeaReferenceTypesDTO>;
  reference_type: ValueOf<typeof SeaReferenceTypesDTO>;
  sealine: string;
  carrier_code: string;
  "shipment-type": Lowercase<ValueOf<typeof ShipmentType>>;
  carrier: string;
  carrierCode: string;
};

type QueryParamsManagerType = QueryParamsManager<PossibleUrlQueryParams, keyof PossibleUrlQueryParams>;

export const createInitialSearchQPM = (): QueryParamsManagerType => {
  const urlBehaviour = store.getState().app.appConfig.urlBehaviour;
  const currentUrl =
    urlBehaviour === BehaviourType.Query ? window.location.href.replace(/(\?.*?)\?/g, "$1&") : window.location.href;

  return new QueryParamsManager<PossibleUrlQueryParams, keyof PossibleUrlQueryParams>(
    currentUrl,
    [
      "number",
      "reference_number",
      "airline",
      "awb_number",
      "container",
      "type",
      "reference_type",
      "sealine",
      "carrier_code",
      "shipment-type",
      "carrier",
      "carrierCode",
    ],
    {
      nonDeletableParams: ["shipment-type"],
      urlBehaviour,
    }
  );
};

let _initialSearchQPM: QueryParamsManagerType | null = null;

export const getInitialSearchQPM = (): QueryParamsManagerType => {
  if (!_initialSearchQPM) {
    _initialSearchQPM = createInitialSearchQPM();
  }
  return _initialSearchQPM;
};

// Reset the singleton instance (call this when component unmounts)
export const resetInitialSearchQPM = (): void => {
  _initialSearchQPM = null;
};
